import Product from '../product';

export default class OtherProduct extends Product {
  otherProductName?: string;
  otherProductMaterial?: string;
  width?: number;
  height?: number;

  constructor() {
    super();
    this.type = 'OtherProduct';
  }

  // Override
  public canSubmitAsClient(): boolean {
    return this.width != null && this.height != null;
  }
}
